<template>
	<div class="aup-public-profile-more-members aup-container h-100">
		<div class="aup-lined-text d-flex align-items-center mb-8 text-center">
			<h2 class="aup-public-profile-more-members__title text-white t-heavy mr-lg-3 aup-lined-text__heading">
				Discover More Members
			</h2>
			<div class="aup-lined-text__line d-none d-lg-block"></div>
		</div>

		<div class="row justify-content-center justify-content-lg-start" v-if="memberProfiles">
			<!-- TODO: SETUP LOADER FOR WHEN MEMBERS HAVENT LOADED -->
			<BaseMembersCard
				v-for="member in memberProfiles.moreProfiles"
				:key="member.ppd_publicprofileid"
				:profileLink="member.ppd_profileurl"
				:name="member.ppd_displayname"
				:avatar="member.picture_profile"
				:backdropImage="member.picture_backdrop"
				class="col-12 col-sm-9 col-md-6 col-lg-3"
			/>
		</div>
	</div>
</template>
<script>
import BaseMembersCard from '@/components/global/BaseMembersCard';

export default {
	name: 'MoreMembers',
	components: {
		BaseMembersCard
	},
	props: {
		memberProfiles: {
			type: Object,
			default: () => {}
		}
	},
	// computed: {
	// 	tempFilteredProfiles() {
	// 		//lets remove any profiles in the more members endpoint that aren't public
	// 		return this.memberProfiles.moreProfiles.filter(member => {
	// 			return member.ppd_ispublic;
	// 		})
	// 	}
	// }
};
</script>
<style lang="scss">
@import '../../assets/scss/all';
.aup-public-profile-more-members {
	height: 30vh;
	width: 100vw;
	&__title {
		@include media-breakpoint-down(md) {
			width: 100%;
		}
	}
}
</style>
